import React, { Component } from 'react'
import { ApolloProvider } from 'react-apollo'
import { ApolloClient } from 'apollo-client'
import { createUploadLink } from 'apollo-upload-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ThemeProvider } from 'styled-components'
import PropTypes from 'prop-types'
import PriorityNotes from '../priority_notes'
import { authLink } from '../shared/ApolloClient'

const uploadLink = createUploadLink({ uri: '/api/graphs' })

const client = new ApolloClient({
  link: authLink.concat(uploadLink),
  cache: new InMemoryCache(),
})

const theme = {
  text: '#56565A',
  link: '#3399CC',
  linkHover: '#ce7019',
  white: '#FFFFFF',
  border: '#9B9B9B'
}

export default class TopLevelLayout extends Component {
  render() {
    const {loanId,
      isBankUser,
      currentAdminId,
    } = this.props
    return (
      <ApolloProvider client={client}>
        <ThemeProvider theme={theme}>
          <PriorityNotes 
            loanId={loanId}
            isBankUser={isBankUser}
            currentAdminId={currentAdminId}
          />
        </ThemeProvider>
      </ApolloProvider>
    )
  }
}
TopLevelLayout.propTypes = {
  loanId: PropTypes.number.isRequired,
  isBankUser: PropTypes.bool,
  currentAdminId: PropTypes.number.isRequired,
}